function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M24 16H6v2h18v-2zm-6 4v2H6v-2h12zm-4 4H6v2h8v-2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 4a4 4 0 1 1 5 3.874V10h11a3 3 0 0 1 3 3v9.172a3 3 0 0 1-.879 2.12l-6.828 6.83a3 3 0 0 1-2.121.878H4a3 3 0 0 1-3-3V13a3 3 0 0 1 3-3h11V7.874A4.002 4.002 0 0 1 12 4zm4-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm13 11v9.013a1.609 1.609 0 0 0-.207-.013H22.5a1.5 1.5 0 0 0-1.5 1.5v6.293c0 .07.005.14.013.207H4a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h11v1a1 1 0 1 0 2 0v-1h11a1 1 0 0 1 1 1zm-1.414 11L23 28.586V24h4.586z",
  clipRule: "evenodd"
});

var SvgRequests = function SvgRequests(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "3727a98a7075084a647e72127218a0af.svg";
export { SvgRequests as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/requests.svg
// module id = null
// module chunks = 